/**
 * Application route constants
 * Centralized route definitions for maintainability and type safety
 */

export const ROUTES = {
  HOME: '/',

  // Public routes
  FAIRS: '/fairs',
  FAIR_DETAILS: '/fair/:fairId',
  FAIR_CALENDAR: '/fairs/calendar',
  VENDORS: '/vendors',
  VENDOR_DETAILS: '/vendors/:vendorId',
  CONTACT: '/contact',

  // Authentication routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  EMAIL_SENT: '/email-sent',

  // User routes
  PROFILE: '/profile',
  RESERVATIONS: '/reservations',
  RESERVATION_DETAILS: '/reservations/:reservationId',
  RESERVATION_CONFIRMED: '/reservation-confirmed',
  FAIR_MANAGER_REQUEST: '/fair-manager-request',

  // Fair Manager routes
  FAIR_MANAGER: {
    ROOT: '/fairmanager',
    DASHBOARD: '/fairmanager/dashboard',
    FAIRS: '/fairmanager/fairs',
    FAIR_NEW: '/fairmanager/fair/new',
    FAIR_EDIT: '/fairmanager/fair/:fairId/edit',
    PAYOUTS: '/fairmanager/payouts',
    RESERVATIONS: '/fairmanager/reservations',
    WAITLIST: '/fairmanager/waitlist',
    RENTAL_EQUIPMENT: '/fairmanager/rental-equipment',
    SLOT_PRICING: '/fairmanager/slot-pricing',
  },

  // Vendor routes
  VENDOR: {
    DASHBOARD: '/vendor/dashboard',
    PROFILE_NEW: '/vendor/profile/new',
    PROFILE_EDIT: '/vendor/profile/:vendorId/edit',
    PRODUCTS: '/vendor/products',
    PRODUCT_NEW: '/vendor/products/new',
    PRODUCT_EDIT: '/vendor/products/:productId/edit',
    WAITLIST: '/vendor/waitlist',
    AD_PURCHASE: '/vendor/ad-purchase',
    AD_PURCHASES: '/vendor/ad-purchases',
  },

  // Admin routes
  ADMIN: {
    DASHBOARD: '/admin',
    // USERS: '/admin/users', // Removed (Issue #1245) - use ROLES for user management
    ROLES: '/admin/roles', // RBAC user and role management (Issue #827)
    VENDORS: '/admin/vendors',
    FAIRS: '/admin/fairs',
    FAIR_EDIT: '/admin/fair/:fairId/edit',
    RESERVATIONS: '/admin/reservations',
    FEATURE_FLAGS: '/admin/feature-flags',
    FAIR_MANAGER_REQUESTS: '/admin/fair-manager-requests',
    AD_PACKAGES: '/admin/ad-packages',
    PRELAUNCH_SIGNUPS: '/admin/prelaunch-signups',
    WAITLIST_ANALYTICS: '/admin/waitlist-analytics',
  },

  // Slot routes
  SLOT_SEARCH: '/fairs/:fairId/slots',
  SLOT_RESERVE: '/slots/:slotId/reserve',
} as const;

/**
 * Helper function to build route with parameters
 * @example buildRoute(ROUTES.FAIR_DETAILS, { fairId: '123' }) => '/fair/123'
 */
export function buildRoute(route: string, params: Record<string, string | number>): string {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, String(value));
  });
  return result;
}
